// custom hooks
import { useAppDispatch } from 'redux/hooks/useAppDispatch';
import { useAppSelector } from 'redux/hooks/useAppSelector';
// slices
import {
  TSidePanelContentType,
  handleOpenSidePanel,
  handleSetProjectId,
  handleSetSidePanelContent,
  setCollapseFullScreen,
  setFullScreen,
  handleSetMentionedProfile,
  handleResetMentionedProfile,
  handleSetEditorExpanded,
} from 'redux/slices/side-panel-slice';
// selectors
import { sidePanelSelector } from 'redux/selector';
// api
import { useUpdateProfilePreferenceMutation } from 'redux/api/profile-preference';
import { IProjectProfiles } from 'redux/api/projects';

export const useSidePanel = () => {
  const dispatch = useAppDispatch();
  const {
    projectId,
    isOpen,
    isFullScreen,
    sidePanelContent,
    mentionedProfile,
    isEditorExpanded,
    editorKey,
  } = useAppSelector(sidePanelSelector);

  const [updateProfilePreference] = useUpdateProfilePreferenceMutation();

  const handleSidePanelOpen = (open: boolean) => {
    dispatch(handleOpenSidePanel(open));
  };

  const handleSidePanelContent = (contentType: TSidePanelContentType) => {
    dispatch(handleSetSidePanelContent(contentType));
  };

  const handleSetFullScreen = () => {
    dispatch(setFullScreen());
  };

  const handleCollapseFullScreen = () => {
    dispatch(setCollapseFullScreen());
  };

  const setProjectId = (id: number) => {
    dispatch(handleSetProjectId(id));
  };

  const handleExpandeEditor = (expanded: boolean) => {
    dispatch(handleSetEditorExpanded(expanded));
  };

  const onSetMentionedProfile = (mentionedUser: IProjectProfiles) => {
    dispatch(handleSetMentionedProfile(mentionedUser));
  };

  const onResetMentionedProfile = () => {
    dispatch(handleResetMentionedProfile());
  };

  const handleOpenActivityFeed = () => {
    dispatch(handleSetSidePanelContent('activity_feed'));
    dispatch(handleOpenSidePanel(true));
    updateProfilePreference({ isActivityFeedExpanded: true });
  };

  const handleCloseActivityFeed = () => {
    dispatch(handleOpenSidePanel(false));
    updateProfilePreference({ isActivityFeedExpanded: false });
  };

  return {
    handleSidePanelOpen,
    handleSidePanelContent,
    handleSetFullScreen,
    handleCollapseFullScreen,
    projectId,
    setProjectId,
    handleOpenActivityFeed,
    handleCloseActivityFeed,
    isSidePanelOpen: isOpen,
    isFullScreen,
    sidePanelContent,
    handleExpandeEditor,
    onResetMentionedProfile,
    onSetMentionedProfile,
    mentionedProfile,
    isEditorExpanded,
    editorKey,
  };
};
